import { Instagram, CreditCard, Banknote, Link2 } from "lucide-react";
import { scrollToId } from "../lib/format";

const NAV = [
  { label: "Inicio", id: "inicio" },
  { label: "Catálogo", id: "catalogo" },
  { label: "Ofertas", id: "ofertas" },
  { label: "Lanzamientos", id: "lanzamientos" },
  { label: "Eventos", id: "eventos" },
  { label: "Contacto", id: "contacto" },
];

export default function Footer({ settings }) {
  return (
    <footer data-testid="site-footer" className="bg-espresso text-cream">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="leading-none">
              <span className="font-display text-5xl tracking-[0.15em]">MO</span>
              <span className="font-serif italic text-copper text-2xl ml-2">by Vir</span>
            </div>
            <p className="text-cream/60 font-light mt-6 max-w-sm leading-relaxed">
              Boutique 100% virtual de mini perfumes, carteras y accesorios para mujer.
              Cada pedido se coordina con cariño por WhatsApp.
            </p>
            <a
              data-testid="footer-instagram"
              href={settings?.instagram_url || "#"}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-copper hover:text-cream transition-colors text-sm uppercase tracking-[0.15em]"
            >
              <Instagram size={17} /> @Mo_ByVir
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.2em] text-cream/40">
              Navegación
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`footer-nav-${n.id}`}
                    onClick={() => scrollToId(n.id)}
                    className="text-cream/80 hover:text-copper transition-colors font-light"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] uppercase tracking-[0.2em] text-cream/40">
              Métodos de pago
            </h4>
            <div className="mt-5 space-y-4 text-cream/80 font-light">
              <p className="flex items-center gap-3">
                <Link2 size={17} className="text-copper" /> Link de pago digital (tarjeta)
              </p>
              <p className="flex items-center gap-3">
                <Banknote size={17} className="text-copper" /> Efectivo contra entrega
              </p>
              <p className="flex items-center gap-3">
                <CreditCard size={17} className="text-copper" /> Coordinado vía WhatsApp
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-cream/40 text-xs font-light max-w-xl leading-relaxed">
            MO by Vir es una tienda exclusivamente online. No contamos con dirección física
            abierta al público por el momento. Toda compra se confirma mediante WhatsApp.
          </p>
          <p className="text-cream/40 text-xs">
            © {new Date().getFullYear()} MO by Vir. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
